import React, { useEffect } from 'react';
import { Row, Col, CardBody } from 'reactstrap';
import { find, lowerCase } from 'lodash';
import { useFetch, Field, CardTitle, useSettings } from '@cordata/buffet';
import styled from 'styled-components';
import { useFormikContext } from 'formik';

const ExternalURL = styled.iframe`
  height: calc( 100vh - 60px - 55px );
  width: 100%;
`;

const TreatmentReferralForm = () => {
  const { values, setFieldValue } = useFormikContext();
  const { findLocalTreatment } = useSettings();
  const [outcomeStatus, availableOutcomes] = useFetch('reference-data/reference-medical-event-outcome');

  useEffect(() => {
    if (values.detailObject) {
      setFieldValue('outcomeDate', values.detailObject.outcomeDate);
    }
  }, [values.detailObject]);

  useEffect(() => {
    if (outcomeStatus === 'success') {
      setFieldValue('outcome', find(availableOutcomes, ['attributes.medicalEventOutcomeName', values.detailObject.outcome]));
    }
  }, [outcomeStatus, values.detailObject.outcome]);

  return (
    <>
      <CardBody>
        <CardTitle>Treatment Decision Details</CardTitle>

        {values.status && lowerCase(values.status.attributes.statusLabel) === 'connected' && (
          <Row form>
            <Col sm>
              <Field
                name="outcome"
                type="select"
                options={availableOutcomes}
                loading={outcomeStatus === 'loading'}
                getOptionValue={o => o.attributes.medicalEventOutcomeName}
                getOptionLabel={o => o.attributes.medicalEventOutcomeLabel}
              />
            </Col>

            <Col sm>
              <Field
                name="outcomeDate"
                type="date"
              />
            </Col>
          </Row>
        )}

        {findLocalTreatment && (
          <>
            <Field
              name="searchFLT"
              label="Search for a local treatment facility?"
              placeholder="Yes"
              type="checkbox"
            />

            {values.searchFLT && (
              <ExternalURL seamless src={findLocalTreatment.externalUrl} />
            )}
          </>
        )}
      </CardBody>
    </>
  );
};

export default TreatmentReferralForm;
